import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { DatePickerField } from 'src/components/DatePickerField/DatePickerField';
import Button from 'src/components/Button';
import moment from 'moment';
import s from './ColumnFilters.styles';

const ColumnFilterDate = ({ value, onChange, onRemove, column: { label }, dateLinks }) => {
  const [popupActive, setPopupActive] = useState(false);
  const [updatingByShortcut, setUpdatingByShortcut] = useState(false);

  const { t } = useTranslation();

  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setPopupActive(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const [from, setFrom] = useState(value ? value.from : null);
  const [to, setTo] = useState(value ? value.to : null);

  const onSubmit = () => {
    onChange({
      from: from ? moment(from).format('YYYY-MM-DD') : null,
      to: to ? moment(to).endOf('day').format('YYYY-MM-DD') : null,
    });
    setPopupActive(false);
  };

  useEffect(()=>{
    if(updatingByShortcut) {
      onSubmit();
      setUpdatingByShortcut(false);
    }
  },[from,to]);

  let valueLabel = null;
  if (value.from || value.to) {
    const parts = [];
    parts.push(value.from ? moment(value.from).format('D MMM YYYY') : '...');
    parts.push(value.to ? moment(value.to).format('D MMM YYYY') : '...');
    valueLabel = parts.join(' — ');
  }

  return (
    <s.FilterWrapper>
      <s.FilterLabel
        changed={!!valueLabel}
        onClick={() => setPopupActive(true)}
      >
        <s.FilterRemoveBtn name="cross" onClick={onRemove} />
        {label}: {valueLabel || t('ALL')}
      </s.FilterLabel>
      {popupActive && (
        <s.MorePopup date ref={ref}>
          {
            dateLinks && (<s.DateLinks>
              {
                dateLinks.map((l)=>{
                  return <s.DateLink key={l.name} onClick={() => l.onClick(setFrom, setTo, onSubmit, setUpdatingByShortcut)}>
                    {l.name}
                  </s.DateLink>;
                })
              }
            </s.DateLinks>)
          }
          <DatePickerField
            dateOnly={true}
            label={t('START')}
            maxDate={to ? moment(to).toDate() : null}
            onChange={e => setFrom(e)}
            placeholderText="mm-dd-yyyy"
            value={from}
          />
          <DatePickerField
            dateOnly={true}
            label={t('END')}
            minDate={from ? moment(from).toDate() : null}
            onChange={e => setTo(e)}
            placeholderText="mm-dd-yyyy"
            value={to}
          />
          <s.ButtonsRow>
            <Button onClick={() => onSubmit()} orange sm solid>
              {t('APPLY')}
            </Button>
            <Button ghost onClick={() => setPopupActive(false)} red sm type="button">
              {t('CANCEL')}
            </Button>
          </s.ButtonsRow>
        </s.MorePopup>
      )}
    </s.FilterWrapper>
  );
};

ColumnFilterDate.propTypes = {
  column: PropTypes.shape({
    label: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  dateLinks: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, onClick: PropTypes.func }))
};

export default React.memo(ColumnFilterDate);
